export default function About() {
  return (
		<section className="max-w-4xl space-y-3 py-8 mx-auto">
			<h3 className="text-2xl font-semibold text-text">About</h3>
			<p>I'm a developer who turns ideas into real web applications. </p>
			<p>
				I discovered coding through building solutions for everyday problems,
				and now I create full-stack apps using the MERN/PERN stack.
			</p>
			<p>When I'm not coding, I'm exploring something new about tech.</p>
		</section>
	);
}
